<template>
    <div class="modal fade" :id="modalId" data-keyboard="false" data-backdrop="static" v-show="showModalFlag">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-danger" style="text-transform:uppercase;">{{ title }} </h4>
                    <button type="button" class="close" aria-label="Close" @click="onClose()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div ref="checkboxDialogContent"></div>
                    <div class="custom-control custom-checkbox mt-3">
                        <input :ref="checkboxRef"
                            class="custom-control-input custom-control-input-success custom-control-input-outline"
                            type="checkbox" v-model="internalCheckboxValue" :id="uniqueCheckboxId">
                        <label :for="uniqueCheckboxId" class="custom-control-label">Ghi nhớ không hiển thị lại xác
                            nhận</label>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-outline-dark pull-left" @click="onClose()">&nbsp;{{
                        $t('buttons.close') }}</button>
                    <button type="button" class="btn btn-outline-danger pull-right" @click="handleOnSubmit">&nbsp;{{
                        confirmLabelButton }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, toRefs, watch } from "vue";
import $ from 'jquery';
export default {
    name: "TheConfirmDialog",
    props: {
        title: String,
        confirmLabelButton: String,
        onClose: Function,
        onSubmit: Function,
        modalContent: String,
        modelValue: Boolean, // Thay thế checkboxValue bằng modelValue để liên kết với v-model
        idModal: String,
        submitArgs: {
            type: Array,
            default: () => [], // Default to an empty array if no arguments are passed
        },
        showModalFlag: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            internalCheckboxValue: this.modelValue, // Biến nội bộ để lưu giá trị checkbox
            uniqueContentId: `checkbox-dialog-content-${Math.random().toString(36).substring(2, 9)}`, // Generate a unique ID
            uniqueCheckboxId: `checkbox-memo-${Math.random().toString(36).substring(2, 9)}`, // Generate a unique ID
            checkboxRef: `checkboxMemoRef-${Math.random().toString(36).substring(2, 9)}`, // Generate a unique ref
            modalId: this.idModal || '_' + Math.random().toString(36).substr(2, 9),
        };
    },
    methods: {
        emitCheckboxChange() {
            this.$emit('update:modelValue', this.internalCheckboxValue); // Tự động phát sự kiện khi giá trị thay đổi
        },
        handleOnSubmit() {
            if (typeof this.onSubmit === 'function') {
                this.onSubmit(...this.submitArgs);
            } else {
                console.error('onSubmit is not a function');
            }
        },

        showModal() {
            this.$emit('update:showModalFlag', true); // Notify parent to sync state
            $('#' + this.modalId).modal('show');
        },
        closeModal() {
            this.$emit('update:showModalFlag', false); // Notify parent to sync state
            $('#' + this.modalId).modal('hide');
        },
    },
    watch: {
        modelValue(newVal) {
            this.internalCheckboxValue = newVal; // Cập nhật giá trị biến nội bộ khi prop thay đổi
        },
        modalContent(newContent) {
            if (this.$refs.checkboxDialogContent) {
                this.$refs.checkboxDialogContent.innerHTML = newContent || '';
            }
        },
        internalCheckboxValue(newVal) {
            this.emitCheckboxChange(); // Gọi hàm emit khi giá trị của biến nội bộ thay đổi
        },

        showModalFlag(newVal) {
            if (newVal) {
                this.showModal();
            } else {
                this.closeModal();
            }
        },
    },
    mounted() {
        if (this.$refs.checkboxDialogContent) {
            this.$refs.checkboxDialogContent.innerHTML = this.modalContent;
        }
    },
}
</script>
<style></style>